// Fichier : Sidebar.tsx
// Ce fichier contient la définition et l'implémentation de la barre latérale (sidebar) de l'application.

import { logout } from "@/state/authSlice";
import { IconUserFilled } from "@tabler/icons-react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./Sidebar.module.css";
import { IconTableFilled } from "@tabler/icons-react";

const Sidebar = () => {
  const dispatch = useDispatch(); // Hook pour dispatcher des actions Redux .

  // Fonction pour gérer la déconnexion
  const handleLogout = () => {
    dispatch(logout()); // Déclenche l'action de déconnexion . Cette Action va étre déclencher par le button logout <
  };

  const navigate = useNavigate(); // Hook pour la navigation
  const location = useLocation(); // Hook pour obtenir l'emplacement actuel , on en a besoin pour lire le contenu du lien.

  // Fonction pour vérifier si le chemin est actif
  const isActive = (path: string) => location.pathname.includes(path); // là , si la "path" donné est inclus dans le lien . isActive sera True.

  return (
    <div className={styles.sidebar}>
      <div className={styles.containerCloseSidebar}>
        <h1 className={styles.title}>Super Admin</h1>
      </div>
      <div className={styles.containerNav}>
        <ul className={styles.navList}>
          {/* Élément de navigation pour les utilisateurs */}
          <li
            onClick={() => navigate("/users/all")}
            className={
              isActive("/users") ? styles.activeTab : styles.inactiveTab
            } // si le lien contient la path "/users" , la Tabs user va avoir un style différent sur la Sidebar
          >
            <IconUserFilled size={"20"} />
            <p>Users</p>
          </li>
          {/* Élément de navigation pour les onglets */}
          <li
            onClick={() => navigate("/tabs/all")}
            className={
              isActive("/tabs") && !isActive("/users")
                ? styles.activeTab
                : styles.inactiveTab
            } // si le lien contient la path "/tabs" , la Tabs user va avoir un style différent sur la Sidebar
          >
            <IconTableFilled size={"20"} />
            <p>Tabs</p>
          </li>
        </ul>
        {/* Bouton de déconnexion */}
        <div className={styles.buttonContainer}>
          <button onClick={handleLogout} className={styles.logout}>
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
